import Resolution from 'engine/Resolution.js';

const BASE = new Resolution(32, false);

export const getStepData = (track, stepNumber, note, resolution) => {
    let _stepNumber = BASE.transformStepAtResolution2(stepNumber, resolution);
    let position = _stepNumber - Math.floor(_stepNumber);
    let steps = track.getEasyPattern().pattern.getPolyphonicStepsAtResolution(Math.floor(_stepNumber), BASE)
        .filter(x => x.position === position)
        .map(x => x.step);
    return steps.find(x => x.transpose === note);
};
